export function getCommonOptionChart(title, dataArray) {
  const options = {
    title: {
      text: title,
      padding: 20,
      textStyle: {
        fontSize: 16,
      },
    },
    yAxis: {
      data: dataArray.map((element) => element[0]),
    },
    label: {
      show: true,
      position: [15, '35%'],
      formatter: '{b}',
      fontSize: 10,
      align: 'left',
      color: '#000',
    },
    grid: {
      top: '20%',
    },
    series: [
      {
        data: dataArray.map((element) => element[1]),
        itemStyle: {
          color: (params) => {
            const colors = [
              '#B7C258',
              '#A3BF62',
              '#8EBC6D',
              '#7AB877',
              '#65B581',
              '#50B28B',
            ];
            return colors[params.dataIndex];
          },
        },
      },
    ],
  };
  return options;
}
